import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpsVendorListEnum } from '@app/shared/constants/global.enum';
import { OpsVendorListResponse } from '@app/shared/interfaces/ops-vendor-list';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OpsVendosListService {
  private baseUrl = environment.apiUrl;
  OpsVendorListEnum = OpsVendorListEnum;

  constructor(
    private http: HttpClient,
    private toaster: ToastrService,
  ) {}

  getOnboarded(): Observable<OpsVendorListResponse> {
    return this.http
      .get<OpsVendorListResponse>(`${this.baseUrl}/ops/all-vendors`)
      .pipe(
        catchError((error) => {
          this.toaster.error(this.OpsVendorListEnum.ServiceError);
          return throwError(error);
        }),
      );
  }
}
